export default {
  form: {
    country: {
      label: 'Paese',
      placeholder: 'Seleziona paese',
    },
  },
};
